const _i18n_info = {
  login_lock: {
    EN: `Please wait, I\'m trying to login.`,
    KO: `Please wait, I\'m trying to login.`,
    JP: `少々お待ちください、ログイン試行中です`
  },
  require : {
    EN: `require`,
    KO: `require`,
    JP: `必須`,
  },
  opt_check : {
    EN: `please input OTP`,
    KO: `please input OTP`,
    JP: `OTPを入力してください`
  },
  change_password: {
    EN: `now the password change cycle reached, now change it ?`,
    KO: `비밀번호 변경 주기에 도달했습니다. 변경하시겠습니까?`,
    JP: `パスワード変更周期に達しました。変更しますか?`,
  },
  loggedin: {
    EN: `Try to login`,
    KO: `로그인 요청!`,
    JP: `ログインを試す`,
  },
}

const _i18n_error = {
  login_failed : {
    EN: `Check your ID`,
    KO: `Check your ID`,
    JP: `IDを確認してください`
  },
  login_failed_2 : {
    EN: `Please check your password`,
    KO: `Please check your password`,
    JP: `パスワードを確認してください`
  },
  error: {
    EN: `unexpected error.`,
    KO: `unexpected error.`,
    JP: `予期せぬエラーが発生しました`
  }
}

const i18n_toastr = {
  _i18n_info,
  _i18n_error
}

export default i18n_toastr